import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { ModalForm } from "components/ModalForm/ModalForm";
import { SelectBox } from "components/Select/Select";
import { Toast } from "components/ToastShow/ToastAlert";
import { MessageType } from "types/enum";
import { trans } from "utils/helpers";
import "./style.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { forwardRef, useEffect, useState } from "react";

interface ConditionFormatFormProps {
  setShowOpenPrintFormatCondition: (show: boolean) => void;
  removeReportAsync: (id: string) => void;
  showOpenPrintFormatCondition: boolean;
  options: { Id: string; Name: string }[];
  selecetedPrintTemplate: string;
  selectboxValSetter: (id: string, data?: any) => void;
  setasdefault: (id: string) => void;
  setSelecetdPrintTemplate: (id: string) => void;
  objectTag?:any
}

export const ConditionFormatForm = forwardRef<
  HTMLFormElement,
  ConditionFormatFormProps
>(function ConditionFormatForm(
  {
    setShowOpenPrintFormatCondition,
    removeReportAsync,
    showOpenPrintFormatCondition,
    options,
    selecetedPrintTemplate,
    selectboxValSetter,
    setasdefault,
    setSelecetdPrintTemplate,
    objectTag
  },
  ref
) {
  const [checkBoxList, setCheckBoxList] = useState<any>();
  const hasConditionFormList = [
    "SalesContractForm",
    "SalesInvoiceForm",
    "SalesOrderForm",
    "SalesPreInvoiceForm",
    "SalesReturnInvoiceForm",
  ];
  const showMoreOption=hasConditionFormList.some(item=>objectTag==item)
  const handleSubmitConditionForm = (e) => {
    e.preventDefault();
    const data: any = {
      UseWarmSignature: e.target?.UseWarmSignature?.checked,
      ShowHeader: e.target?.ShowHeader?.checked,
      ShowSignature: e.target?.ShowSignature?.checked,
      ShowCustomerTitle: e.target?.ShowCustomerTitle?.checked,
   ...(showMoreOption?{   ShowCompanyInfo: e.target?.ShowCompanyInfo?.checked,
      ShowCustomerCode: e.target?.ShowCustomerCode?.checked,
      ShowItemDescription: e.target?.ShowItemDescription?.checked,
      ShowDescription: e.target?.ShowDescription?.checked,
      ShowAddress: e.target?.ShowAddress?.checked,
      ShowPayments: e.target?.ShowPayments?.checked,
      ShowUnit1: e.target?.ShowUnit1?.checked,
      ShowUnit2: e.target?.ShowUnit2?.checked,
      ShowCustomerRemaining: e.target?.ShowCustomerRemaining?.checked,
      ShowSumOfSimilarDetails: e.target?.ShowSumOfSimilarDetails?.checked,}:{})
    };

    if (e.nativeEvent.submitter.name == "edit") {
      selectboxValSetter(selecetedPrintTemplate + "Design", data);
    } else {
      selectboxValSetter(selecetedPrintTemplate, data);
    }
    localStorage.setItem("PrintTemplateCondition", JSON.stringify(data));
  };

  useEffect(() => {
    if (localStorage.getItem("PrintTemplateCondition")) {
      setCheckBoxList({   
        UseWarmSignature: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.UseWarmSignature
          : false,
     ShowSignature: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowSignature
          : false,
           ShowCustomerTitle: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowCustomerTitle
          : false,
            ShowHeader: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowHeader
          : false,

...(showMoreOption?{
   ShowCustomerCode: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowCustomerCode
          : false,
 
      
             ShowCompanyInfo: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowCompanyInfo
          : false,

        ShowItemDescription: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowItemDescription
          : false,
        ShowDescription: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowDescription
          : false,
        ShowAddress: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowAddress
          : false,
        ShowPayments: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowPayments
          : false,
        ShowUnit1: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowUnit1
          : false,
        ShowUnit2: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowUnit2
          : false,
           ShowCustomerRemaining: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowCustomerRemaining
          : false,
           ShowSumOfSimilarDetails: localStorage.getItem("PrintTemplateCondition")
          ? JSON.parse(localStorage.getItem("PrintTemplateCondition") as any)
              ?.ShowSumOfSimilarDetails
          : false,
}:{})

     
      });
    }
  }, [localStorage.getItem("PrintTemplateCondition")]);

  return (
    <>
      {showOpenPrintFormatCondition ? (
        <ModalForm
          modalHeight={49}
          //    mode={mode}
          onHide={() => {
            setShowOpenPrintFormatCondition(false);
          }}
          show={showOpenPrintFormatCondition}
          title={"PrintOptionsForm"}
        >
          <form onSubmit={handleSubmitConditionForm} ref={ref}>
            <div className="row">
              <div className="col-8">
                <div className="row">
                  <div className="col-6">
                    <SelectBox
                      Change={(e) => setSelecetdPrintTemplate(e)}
                      selectType="selectThin"
                      options={!!options?.length ?options?.map((item) => item?.Name):[]}
                      val={!!options?.length ?options?.map((item) => item?.Id):[]}
                      onChange={(e) => {
                        setSelecetdPrintTemplate(e.target?.value);
                      }}
                      value={null}
                      name="test"
                    />
                  </div>
                  <div className="col-6 d-flex align-items-center">
                    <OverlayTrigger
                      key={"edit"}
                      placement="top"
                      delay={{ show: 600, hide: 0 }}
                      overlay={
                        <Tooltip
                          className="tooltip "
                          id={`button-tooltip-${"reserve"}`}
                        >
                          {trans("edit")}
                        </Tooltip>
                      }
                    >
                      <button
                        name="edit"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        className="btn btn-sm ms-1 btn-primary d-flex justify-content-center align-items-center customBtnSize p-1"
                      >
                        <FontAwesomeIcon
                          style={{ fontSize: "12px" }}
                          color={"white"}
                          icon={["fas", "edit"]}
                        />
                      </button>
                    </OverlayTrigger>

                    <OverlayTrigger
                      key={"trash"}
                      placement="top"
                      delay={{ show: 600, hide: 0 }}
                      overlay={
                        <Tooltip
                          className="tooltip "
                          id={`button-tooltip-${"reserve"}`}
                        >
                          {trans("delete")}
                        </Tooltip>
                      }
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          Toast(
                            trans("msg_deleteconfirm"),
                            MessageType.confirmDelete,
                            () => {
                              removeReportAsync(selecetedPrintTemplate);
                            }
                          );
                        }}
                        className="btn btn-sm ms-1 btn-danger d-flex justify-content-center align-items-center customBtnSize p-1"
                      >
                        <FontAwesomeIcon
                          className=""
                          style={{ fontSize: "12px" }}
                          color={"white"}
                          icon={["fas", "trash"]}
                        />
                      </button>
                    </OverlayTrigger>

                    <OverlayTrigger
                      key={"square-check"}
                      placement="top"
                      delay={{ show: 600, hide: 0 }}
                      overlay={
                        <Tooltip
                          className="tooltip "
                          id={`button-tooltip-${"reserve"}`}
                        >
                          {trans("setAsDefault")}
                        </Tooltip>
                      }
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setasdefault(selecetedPrintTemplate);
                        }}
                        className="btn btn-sm ms-1 btn-warning d-flex justify-content-center align-items-center customBtnSize p-1"
                      >
                        <FontAwesomeIcon
                          className=""
                          style={{ fontSize: "12px" }}
                          color={"white"}
                          icon={["fas", "square-check"]}
                        />
                      </button>
                    </OverlayTrigger>

                    <OverlayTrigger
                      key={"pluss"}
                      placement="top"
                      delay={{ show: 600, hide: 0 }}
                      overlay={
                        <Tooltip
                          className="tooltip "
                          id={`button-tooltip-${"reserve"}`}
                        >
                          {trans("add")}
                        </Tooltip>
                      }
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          selectboxValSetter("Design");
                        }}
                        className="btn btn-sm ms-1 btn-success d-flex justify-content-center align-items-center customBtnSize p-1"
                      >
                        <FontAwesomeIcon
                          className=""
                          style={{ fontSize: "12px" }}
                          color={"white"}
                          icon={["fas", "plus"]}
                        />
                      </button>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
     
                    <div className="col-sm-6 mt-1 mt-4">
                   <CheckableButton
                  defaultChecked={checkBoxList?.ShowSignature}
                  defaultValue={checkBoxList?.ShowSignature}
                  labelText={"ShowSignature"}
                  inputName={"ShowSignature"}
                  type="checkbox"
                  mode={"edit"}
                  onchange={(e)=>{if(!e){
                    setCheckBoxList({...checkBoxList,ShowSignature:e,UseWarmSignature:false})
                  }else{
                    setCheckBoxList({...checkBoxList,ShowSignature:e})
                  }}}
                />
              </div>
                <div className="col-sm-6 mt-1 mt-4">
                <CheckableButton
                  defaultChecked={checkBoxList?.ShowHeader}
                  defaultValue={checkBoxList?.ShowHeader}
                  labelText={"ShowHeader"}
                  inputName={"ShowHeader"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
         
               <div className="col-sm-6 ">
                <CheckableButton
                  defaultChecked={checkBoxList?.UseWarmSignature}
                  defaultValue={checkBoxList?.UseWarmSignature}
                  labelText={"UseWarmSignature"}
                  inputName={"UseWarmSignature"}
                  type="checkbox"
                  value={checkBoxList?.UseWarmSignature}
                  checked={checkBoxList?.UseWarmSignature}
                  readOnly={!checkBoxList?.ShowSignature}
                  onchange={(e)=>{
                    setCheckBoxList({...checkBoxList,UseWarmSignature:e})
                 }}
                />
              </div>


                <div className="col-sm-6 mt-1">
                   <CheckableButton
                  defaultChecked={checkBoxList?.ShowCustomerTitle}
                  defaultValue={checkBoxList?.ShowCustomerTitle}
                  labelText={"ShowCustomerTitle"}
                  inputName={"ShowCustomerTitle"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
              {showMoreOption ?<>
              
                 <div className="col-sm-6">
                <CheckableButton
                  defaultChecked={checkBoxList?.ShowCompanyInfo}
                  defaultValue={checkBoxList?.ShowCompanyInfo}
                  labelText={"ShowCompanyInfo"}
                  inputName={"ShowCompanyInfo"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
              <div className="col-sm-6 mt-1">
                <CheckableButton
                  defaultChecked={checkBoxList?.ShowCustomerCode}
                  defaultValue={checkBoxList?.ShowCustomerCode}
                  labelText={"ShowCustomerCode"}
                  inputName={"ShowCustomerCode"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
           
              <div className="col-sm-6 mt-1">
                <CheckableButton
                  defaultChecked={checkBoxList?.ShowItemDescription}
                  defaultValue={checkBoxList?.ShowItemDescription}
                  labelText={"ShowItemDescription"}
                  inputName={"ShowItemDescription"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
              <div className="col-sm-6 mt-1">
                <CheckableButton
                  defaultChecked={checkBoxList?.ShowDescription}
                  defaultValue={checkBoxList?.ShowDescription}
                  labelText={"ShowDescription"}
                  inputName={"ShowDescription"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
              <div className="col-sm-6 mt-1">
                <CheckableButton
                  defaultChecked={checkBoxList?.ShowAddress}
                  defaultValue={checkBoxList?.ShowAddress}
                  labelText={"ShowAddress"}
                  inputName={"ShowAddress"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
              <div className="col-sm-6 mt-1">
                <CheckableButton
                  onchange={(e) =>
                    setCheckBoxList({ ...checkBoxList, ShowPayments: e })
                  }
                  defaultChecked={checkBoxList?.ShowPayments}
                  defaultValue={checkBoxList?.ShowPayments}
                  labelText={"ShowPayments"}
                  inputName={"ShowPayments"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
              <div className="col-sm-6 mt-1">
                <CheckableButton
                  defaultChecked={checkBoxList?.ShowUnit1}
                  defaultValue={checkBoxList?.ShowUnit1}
                  labelText={"ShowUnit1"}
                  inputName={"ShowUnit1"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
              <div className="col-sm-6 mt-1">
                <CheckableButton
                  defaultChecked={checkBoxList?.ShowUnit2}
                  defaultValue={checkBoxList?.ShowUnit2}
                  labelText={"ShowUnit2"}
                  inputName={"ShowUnit2"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
              <div className="col-sm-6 mt-1">
                   <CheckableButton
                  defaultChecked={checkBoxList?.ShowSumOfSimilarDetails}
                  defaultValue={checkBoxList?.ShowSumOfSimilarDetails}
                  labelText={"ShowSumOfSimilarDetails"}
                  inputName={"ShowSumOfSimilarDetails"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
                <div className="col-sm-6 mt-1">
                   <CheckableButton
                  defaultChecked={checkBoxList?.ShowCustomerRemaining}
                  defaultValue={checkBoxList?.ShowCustomerRemaining}
                  labelText={"ShowCustomerRemaining"}
                  inputName={"ShowCustomerRemaining"}
                  type="checkbox"
                  mode={"edit"}
                />
              </div>
              
              </>:<></>}
           
                
            </div>

            <div className="row justify-content-end col-12">
              <div className="col-1 text-start">
                <Button
                  value="print"
                  customClass={"not-inherit"}
                  btnType="submit"
                />
              </div>
            </div>
          </form>
        </ModalForm>
      ) : (
        <></>
      )}
    </>
  );
});
